import { useEffect, useState } from 'react';
import './App.css';
import Card from './component/Card';

function App() {
  const [advice, setAdvice] = useState('');
  const [id, setId] = useState('');



// Run only once on component mount

  const fetchAdvice = () => {
    fetch("https://api.adviceslip.com/advice")
      .then((res) => res.json())
      .then((data) => {
        setAdvice(data.slip.advice);
        setId(data.slip.id);
      })
      .catch((error) => console.error('Error fetching advice:', error));
  };
  const handleClick = () => {
    fetchAdvice();// Call the function to fetch advice on button click
  };
  useEffect(() => {
    fetchAdvice();
  }, []);

  return <div>
      <Card advice={advice} id={id} shuffel = {handleClick} />
    </div>;
}

export default App;
